export default "__VITE_ASSET__b797c11c__"